import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { Buttons } from 'src/app/home/table/Buttons';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { ComboDetails } from 'src/app/models/commission/combo-details.model';
import { KomFeed } from 'src/app/models/commission/kom-feed.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { CommissionService } from 'src/app/service/commission.service';
import { KomFeedService } from 'src/app/service/komfeed.service';
import { NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: 'app-edit-komfeed',
  templateUrl: './edit-komfeed.component.html',
  styleUrls: ['./edit-komfeed.component.css']
})
export class EditKomfeedComponent implements OnInit {
  public komFeedModel = new KomFeed();
  public comboDtl = new ComboDetails();
  public oolDetails: KomFeed[] = [];
  public header: string = 'Edit Feed Data';
  public products: ComboDetails[] = [];
  public productInfo: ComboDetails[] = [];
  public IsmodelShow: boolean = false;
  public controlStr = new FormControl();

  public actions: any;
  public actionButtons: any;
  public buttons: Buttons[] = [];
  public filteredCommStrValues: Observable<ComboDetails[]> | undefined;
  public field: string;
  public ordersTableColumns: TableColumn[];
  public columnsData: any;
  public isStatus: string = "";
  public resHeadder: string = 'KOM Feed Results';
  public multicombo: ComboDetails[] = [];
  public comboDtlAdd = new ComboDetails();
  public check: boolean = true;
  public flags: string[] = ['Y', 'N'];

  public existingOolCurrProducts: ComboDetails[] = [];
  public existingOolPrevProducts: ComboDetails[] = [];
  public existingMiscCurrProducts: ComboDetails[] = [];
  public existingMiscPrevProducts: ComboDetails[] = [];
  public existingPremCurrProducts: ComboDetails[] = [];
  public existingPremPrevProducts: ComboDetails[] = [];
  public existingOVCurrProducts: ComboDetails[] = [];
  public existingOVPrevProducts: ComboDetails[] = [];

  public translateMasterdata: KomFeed[] = [];

  constructor(private komFeedService: KomFeedService, private commissionService: CommissionService,
    private notificationService: NotificationService, private router: Router, private httpService: HttpClient) { }

  ngOnInit(): void {
    // console.log(this.commissionService.editKomFeedModel);
    this.komFeedModel = this.commissionService.editKomFeedModel;

    this.isStatus = this.commissionService.editKomFeedModel.status;
    // console.log(this.isStatus);

    if (this.isStatus === "Update") {
      this.header = 'Edit Feed Data';
    } else if (this.isStatus === "Replicate") {
      this.header = 'Replicate Feed Data';
    }

    this.comboDtl.position;

    this.multicombo.push(this.comboDtlAdd);
    // console.log("multicombo = "+JSON.stringify(this.multicombo));

    this.getOOLDetails();
    this.getAdminConfigTurfData();
  }

  getAdminConfigTurfData() {
    this.komFeedService.getAdminConfigTurfData()
      .subscribe((data: KomFeed[]) => {
        this.translateMasterdata = data;
        console.log(this.translateMasterdata);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public getOOLDetails() {
    this.komFeedService.getOOLDetails()
      .subscribe((response: any) => {
        this.oolDetails = response;
        // console.log(this.oolDetails);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public back() {
    this.router.navigate(['/feed-results']);
  }

  public save(comboForm: NgForm) {
    this.update();
    this.close(comboForm, 'closeAddKPIButton1');
    this.close(comboForm, 'closeAddKPIButton2');
    this.close(comboForm, 'closeAddKPIButton3');
    this.close(comboForm, 'closeAddKPIButton4');
    this.close(comboForm, 'closeAddKPIButton5');
    this.close(comboForm, 'closeAddKPIButton6');
  }

  public update() {
    //console.log("update Called: " + JSON.stringify(this.komFeedModel));
    //this.komFeedModel.pr_status_id = 1;
    this.komFeedModel.last_modified_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.komFeedModel.last_modified_on = new Date();
    this.komFeedService.updateKomFeedByID(this.komFeedModel).subscribe(
      (response: CustomHttpRespone) => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
      },
      (error: HttpErrorResponse) => {
        this.notificationService.sendNotification(NotificationType.ERROR, error.error.message);
      }
    )
  }

  Replicate() {
    console.log("Replicate Called");
    this.komFeedModel.komfeedid = this.komFeedModel.id;
    console.log(this.komFeedModel.komfeedid);
    this.komFeedModel.id = 0;
    this.komFeedModel.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.komFeedModel.created_dt = new Date();
    console.log(this.komFeedModel);
    this.komFeedService.addNewAdjustment(this.komFeedModel).subscribe(
      (response: CustomHttpRespone) => {
        //console.log(response);
        this.notificationService.sendNotification(NotificationType.SUCCESS, "Inserted Successfully");
        this.router.navigate(['/' + 'feed-results']);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public viewOolCurrent(type: string, field: string) {
    console.log("Inside viewOolCurrent");
    this.existingOolCurrProducts = [];
    this.komFeedModel.svcsType = type;
    this.comboDtl.type = type;
    this.comboDtl.corp = this.komFeedModel.corp;
    this.comboDtl.wfinDate = this.komFeedModel.wfindate;
    this.field = field;

    if (this.komFeedModel.svcsType === 'ool addnl svcs%' && this.field === 'current' && this.komFeedModel.curr_ool_combo_str?.length > 0) {
      console.log("Inside ool current");
      for (let i = 0; i < this.komFeedModel.curr_ool_combo_str?.length; i++) {
        if (this.komFeedModel.curr_ool_combo_str[i] != '0') {
          this.comboDtl.position = i + 1;
          this.comboDtl.currentValue = this.komFeedModel.curr_ool_combo_str[i];
          //console.log(this.comboDtl);
          this.komFeedService.getProduct(this.comboDtl).subscribe(
            (response: ComboDetails) => {
              //console.log(JSON.stringify(response));
              if (response.productName != null) {
                this.existingOolCurrProducts.push(response);
              }
              // console.log(this.existingProducts);
            }, (errorResponse: HttpErrorResponse) => {
              var msg: any;
              msg = errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            }
          )
        }
      }
    }

    this.getProductNames(this.komFeedModel, this.komFeedModel.svcsType, this.field);
  }

  public viewMiscCurrent(type: string, field: string) {
    console.log("Inside viewOolCurrent");
    this.existingMiscCurrProducts = [];
    this.komFeedModel.svcsType = type;
    this.comboDtl.type = type;
    this.comboDtl.corp = this.komFeedModel.corp;
    this.comboDtl.wfinDate = this.komFeedModel.wfindate;
    this.field = field;

    if (this.komFeedModel.svcsType === 'misc%' && this.field === 'current' && this.komFeedModel.curr_misc_combo_str?.length > 0) {
      console.log("Inside ool current");
      for (let i = 0; i < this.komFeedModel.curr_misc_combo_str?.length; i++) {
        if (this.komFeedModel.curr_misc_combo_str[i] != '0') {
          this.comboDtl.position = i + 1;
          this.comboDtl.currentValue = this.komFeedModel.curr_misc_combo_str[i];
          //console.log(this.comboDtl);
          this.komFeedService.getProduct(this.comboDtl).subscribe(
            (response: ComboDetails) => {
              //console.log(JSON.stringify(response));
              if (response.productName != null) {
                this.existingMiscCurrProducts.push(response);
              }
              // console.log(this.existingProducts);
            }, (errorResponse: HttpErrorResponse) => {
              var msg: any;
              msg = errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            }
          )
        }
      }
    }

    this.getProductNames(this.komFeedModel, this.komFeedModel.svcsType, this.field);
  }

  public viewOVCurrent(type: string, field: string) {
    console.log("Inside viewOVCurrent");
    this.existingOVCurrProducts = [];
    this.komFeedModel.svcsType = type;
    this.comboDtl.type = type;
    this.comboDtl.corp = this.komFeedModel.corp;
    this.comboDtl.wfinDate = this.komFeedModel.wfindate;
    this.field = field;

    if (this.komFeedModel.svcsType === 'OV ADDNL SVCS%' && this.field === 'current' && this.komFeedModel.curr_ov_combo_str?.length > 0) {
      console.log("Inside ov current");
      for (let i = 0; i < this.komFeedModel.curr_ov_combo_str?.length; i++) {
        if (this.komFeedModel.curr_ov_combo_str[i] != '0') {
          this.comboDtl.position = i + 1;
          this.comboDtl.currentValue = this.komFeedModel.curr_ov_combo_str[i];
          //console.log(this.comboDtl);
          this.komFeedService.getProduct(this.comboDtl).subscribe(
            (response: ComboDetails) => {
              //console.log(JSON.stringify(response));
              if (response.productName != null) {
                this.existingOVCurrProducts.push(response);
              }
              // console.log(this.existingProducts);
            }, (errorResponse: HttpErrorResponse) => {
              var msg: any;
              msg = errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            }
          )
        }
      }
    }

    this.getProductNames(this.komFeedModel, this.komFeedModel.svcsType, this.field);
  }

  public viewOVPrev(type: string, field: string) {
    console.log("Inside viewOVPrev");
    this.existingOVPrevProducts = [];
    this.komFeedModel.svcsType = type;
    this.comboDtl.type = type;
    this.comboDtl.corp = this.komFeedModel.corp;
    this.comboDtl.wfinDate = this.komFeedModel.wfindate;
    this.field = field;
    if (this.komFeedModel.svcsType === 'OV ADDNL SVCS%' && this.field === 'prev' && this.komFeedModel.prev_ov_combo_str?.length > 0) {
      //console.log("Inside ool prev");
      for (let i = 0; i < this.komFeedModel.prev_ov_combo_str?.length; i++) {
        console.log("I val = " + i);
        if (this.komFeedModel.prev_ov_combo_str[i] != '0') {
          this.comboDtl.position = i + 1;
          this.comboDtl.currentValue = this.komFeedModel.prev_ov_combo_str[i];

          console.log(this.comboDtl);
          this.komFeedService.getProduct(this.comboDtl).subscribe(
            (response: ComboDetails) => {
              // console.log(JSON.stringify(response));
              if (response.productName != null) {
                this.existingOVPrevProducts.push(response);
              }
              console.log(this.existingOVPrevProducts);
            }, (errorResponse: HttpErrorResponse) => {
              var msg: any;
              msg = errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            }
          )
        }
      }

    }
    //console.log(this.existingOVPrevProducts);
    this.getProductNames(this.komFeedModel, this.komFeedModel.svcsType, this.field);
  }

  public viewOolPrev(type: string, field: string) {
    console.log("Inside viewOolPrev");
    this.existingOolPrevProducts = [];
    this.komFeedModel.svcsType = type;
    this.comboDtl.type = type;
    this.comboDtl.corp = this.komFeedModel.corp;
    this.comboDtl.wfinDate = this.komFeedModel.wfindate;
    this.field = field;
    if (this.komFeedModel.svcsType === 'ool addnl svcs%' && this.field === 'prev' && this.komFeedModel.prev_ool_combo_str?.length > 0) {
      //console.log("Inside ool prev");
      for (let i = 0; i < this.komFeedModel.prev_ool_combo_str?.length; i++) {
        console.log("I val = " + i);
        if (this.komFeedModel.prev_ool_combo_str[i] != '0') {
          this.comboDtl.position = i + 1;
          this.comboDtl.currentValue = this.komFeedModel.prev_ool_combo_str[i];

          console.log(this.comboDtl);
          this.komFeedService.getProduct(this.comboDtl).subscribe(
            (response: ComboDetails) => {
              // console.log(JSON.stringify(response));
              if (response.productName != null) {
                this.existingOolPrevProducts.push(response);
              }
              console.log(this.existingOolPrevProducts);
            }, (errorResponse: HttpErrorResponse) => {
              var msg: any;
              msg = errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            }
          )
        }
      }

    }
    //console.log(this.existingOolPrevProducts);
    this.getProductNames(this.komFeedModel, this.komFeedModel.svcsType, this.field);
  }

  public viewMiscPrev(type: string, field: string) {
    console.log("Inside viewOolPrev");
    this.existingMiscPrevProducts = [];
    this.komFeedModel.svcsType = type;
    this.comboDtl.type = type;
    this.comboDtl.corp = this.komFeedModel.corp;
    this.comboDtl.wfinDate = this.komFeedModel.wfindate;
    this.field = field;
    if (this.komFeedModel.svcsType === 'misc%' && this.field === 'prev' && this.komFeedModel.prev_misc_combo_str?.length > 0) {
      //console.log("Inside ool prev");
      for (let i = 0; i < this.komFeedModel.prev_misc_combo_str?.length; i++) {
        console.log("I val = " + i);
        if (this.komFeedModel.prev_misc_combo_str[i] != '0') {
          this.comboDtl.position = i + 1;
          this.comboDtl.currentValue = this.komFeedModel.prev_misc_combo_str[i];

          console.log(this.comboDtl);
          this.komFeedService.getProduct(this.comboDtl).subscribe(
            (response: ComboDetails) => {
              // console.log(JSON.stringify(response));
              if (response.productName != null) {
                this.existingMiscPrevProducts.push(response);
              }
              console.log(this.existingMiscPrevProducts);
            }, (errorResponse: HttpErrorResponse) => {
              var msg: any;
              msg = errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            }
          )
        }
      }

    }
    //console.log(this.existingMiscPrevProducts);
    this.getProductNames(this.komFeedModel, this.komFeedModel.svcsType, this.field);
  }


  getProductNames(komFeedModel: KomFeed, svcsType: string, field: string) {
    this.komFeedService.getProductNames(komFeedModel).subscribe(
      (response: ComboDetails[]) => {
        this.products = response;
        // console.log(this.products);
        this.filterCommStr();

        if (this.komFeedModel.svcsType === 'ool addnl svcs%' && this.field === 'current') {
          document.getElementById('viewOolCurr').click();
        } else if (this.komFeedModel.svcsType === 'ool addnl svcs%' && this.field === 'prev') {
          document.getElementById('viewOolPrev').click();
        } else if (this.komFeedModel.svcsType === 'misc%' && this.field === 'current') {
          document.getElementById('viewMiscCurr').click();
        } else if (this.komFeedModel.svcsType === 'misc%' && this.field === 'prev') {
          document.getElementById('viewMiscPrev').click();
        } else if (this.komFeedModel.svcsType === 'OV ADDNL SVCS%' && this.field === 'current') {
          document.getElementById('viewOVCurr').click();
        } else if (this.komFeedModel.svcsType === 'OV ADDNL SVCS%' && this.field === 'prev') {
          document.getElementById('viewOVPrev').click();
        }

        //this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  deleteOolCurr(product: ComboDetails, kpiForm: NgForm, i: any, value: string) {
    console.log("Inside deleteOolCurr");
    console.log('Delete:', product);
    this.komFeedModel.curr_ool_combo_str = this.komFeedModel.curr_ool_combo_str.substring(0, product.position - 1) +
      0 + this.komFeedModel.curr_ool_combo_str.substring(product.position);
    // this.close(kpiForm, 'closeAddKPIButton');
    console.log('value:', value);
    if (value === 'existing')
      this.existingOolCurrProducts.splice(i, 1);
    else
      this.multicombo.splice(i, 1);
  }

  deleteOolPrev(product: ComboDetails, kpiForm: NgForm, i: any, value: string) {
    console.log("Inside deleteOolPrev");
    console.log('Delete:', product);
    this.komFeedModel.prev_ool_combo_str = this.komFeedModel.prev_ool_combo_str.substring(0, product.position - 1) +
      0 + this.komFeedModel.prev_ool_combo_str.substring(product.position);
    // this.close(kpiForm, 'closeAddKPIButton');
    console.log('value:', value);
    if (value === 'existing')
      this.existingOolPrevProducts.splice(i, 1);
    else
      this.multicombo.splice(i, 1);
  }

  deleteMiscCurr(product: ComboDetails, kpiForm: NgForm, i: any, value: string) {
    console.log("Inside deleteMiscCurr");
    console.log('Delete:', product);
    this.komFeedModel.curr_misc_combo_str = this.komFeedModel.curr_misc_combo_str.substring(0, product.position - 1) +
      0 + this.komFeedModel.curr_misc_combo_str.substring(product.position);
    // this.close(kpiForm, 'closeAddKPIButton');
    console.log('value:', value);
    if (value === 'existing')
      this.existingMiscCurrProducts.splice(i, 1);
    else
      this.multicombo.splice(i, 1);
  }

  deleteMiscPrev(product: ComboDetails, kpiForm: NgForm, i: any, value: string) {
    console.log("Inside deleteMiscPrev");
    console.log('Delete:', product);
    this.komFeedModel.prev_misc_combo_str = this.komFeedModel.prev_misc_combo_str.substring(0, product.position - 1) +
      0 + this.komFeedModel.prev_misc_combo_str.substring(product.position);
    // this.close(kpiForm, 'closeAddKPIButton');
    console.log('value:', value);
    if (value === 'existing')
      this.existingMiscPrevProducts.splice(i, 1);
    else
      this.multicombo.splice(i, 1);
  }

  deleteOVCurr(product: ComboDetails, kpiForm: NgForm, i: any, value: string) {
    console.log("Inside deleteOVCurr");
    console.log('Delete:', product);
    this.komFeedModel.curr_ov_combo_str = this.komFeedModel.curr_ov_combo_str.substring(0, product.position - 1) +
      0 + this.komFeedModel.curr_ov_combo_str.substring(product.position);
    // this.close(kpiForm, 'closeAddKPIButton');
    console.log('value:', value);
    if (value === 'existing')
      this.existingOVCurrProducts.splice(i, 1);
    else
      this.multicombo.splice(i, 1);
  }

  deleteOVPrev(product: ComboDetails, kpiForm: NgForm, i: any, value: string) {
    console.log("Inside deleteOVPrev");
    console.log('Delete:', product);
    this.komFeedModel.prev_ov_combo_str = this.komFeedModel.prev_ov_combo_str.substring(0, product.position - 1) +
      0 + this.komFeedModel.prev_ov_combo_str.substring(product.position);
    // this.close(kpiForm, 'closeAddKPIButton');
    console.log('value:', value);
    if (value === 'existing')
      this.existingOVPrevProducts.splice(i, 1);
    else
      this.multicombo.splice(i, 1);
  }



  filterCommStr() {
    this.filteredCommStrValues = this.controlStr.valueChanges.pipe(
      startWith(''),
      map(value => this._filterStr(value))
    );
  }

  private _filterStr(value: string): ComboDetails[] {
    const filterValue = this._normalizeValue(value);
    return this.products.filter(item => this._normalizeValue(item.productName).includes(filterValue));
  }

  private _normalizeValue(value: string): string {
    return value.toString().toLowerCase().replace(/\s/g, '');
  }

  getCommPlan(kpiForm: NgForm, i: number) {
    console.log("Inside getCommPlan");
    console.log(this.multicombo)
    // kpiForm.reset();
    const comboNew = new ComboDetails()
    this.check = true;
    console.log(this.multicombo[i].productName);
    this.komFeedModel.productName = this.multicombo[i].productName;
    this.komFeedService.getProductInfo1(this.komFeedModel).subscribe(
      (response: ComboDetails[]) => {

        this.productInfo = response;
        console.log(this.productInfo);

        if (this.productInfo.length === 1) {
          this.comboDtl = this.productInfo[0];
          this.multicombo[i].position = this.comboDtl.position;
          if (!this.comboDtl.position || !this.comboDtl.newValue) {
            this.notificationService.sendNotification(NotificationType.WARNING, "The Product is not having postion & Value Select other Product");
          } else if (this.multicombo.length > 1) {
            for (let mcomb of this.multicombo) {
              if (mcomb.position === this.comboDtl.position &&
                mcomb.productName != this.comboDtl.productName) {
                // this.notificationService.sendNotification(NotificationType.WARNING, "Dupppppppp & Value Select other Product");
                if (confirm("For the same Postion " + mcomb.productName + "is mapped Do you want override?"))
                  this.check = true;
                else
                  this.check = false;
              }
            }
          }
          if (this.check) {
            this.multicombo.push(comboNew);
            //console.log("multicombo = " + JSON.stringify(this.multicombo));
            this.modifyCombo();
          }
        } else if (this.productInfo.length > 1) {
          this.notificationService.sendNotification(NotificationType.WARNING, "The Product is having multipule Postion & Values select other Product");
        } else if (this.productInfo.length === 0) {
          this.notificationService.sendNotification(NotificationType.WARNING, "The Product is not having  Postion & Values select other Product");
        } else {
          if (this.komFeedModel.svcsType === 'ool addnl svcs%')
            this.comboDtl.currentValue = this.komFeedModel.curr_ool_combo_str[this.comboDtl.position]
          else if (this.komFeedModel.svcsType === 'ool addnl svcs%')
            this.comboDtl.currentValue = this.komFeedModel.curr_ool_combo_str[this.comboDtl.position]
        }

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
    // if(event.source.selected)
  }

  redirect() {
    this.router.navigate(['/adjustments-feed']);
  }

  modifyCombo() {
    console.log("Inside modifyCombo");
    console.log(this.komFeedModel.svcsType);
    console.log(this.field);

    if (this.komFeedModel.svcsType === 'ool addnl svcs%' && this.field === 'current') {
      this.komFeedModel.curr_ool_combo_str = this.komFeedModel.curr_ool_combo_str.substring(0, this.comboDtl.position - 1) +
        this.comboDtl.newValue + this.komFeedModel.curr_ool_combo_str.substring(this.comboDtl.position);
    } else if (this.komFeedModel.svcsType === 'ool addnl svcs%' && this.field === 'prev') {
      this.komFeedModel.prev_ool_combo_str = this.komFeedModel.prev_ool_combo_str.substring(0, this.comboDtl.position) +
        this.comboDtl.newValue + this.komFeedModel.prev_ool_combo_str.substring(this.comboDtl.position + 1);
    }
    //this.close(kpiForm, 'closeAddKPIButton');
  }

  close(kpiForm: NgForm, id: string) {
    this.multicombo = [];
    this.multicombo.push(this.comboDtlAdd);
    console.log("multicombo = " + this.multicombo);
    kpiForm.reset();
    document.getElementById(id).click();
  }

}
